import React from "react";
import AppRenderer from "../core/components/app-renderer/app-renderer";
import { clientComponents } from "./client-components";
export var ClientApp = function () {
    return React.createElement(AppRenderer, { components: clientComponents });
};
